module.exports = __webpack_public_path__ + "img/cycle-overview-logo.d67cbd4b.svg";